<template>
    <div class="d-flex flex-column ga-2">
        <div class="text-h6 font-weight-bold">Vue d'ensemble de la liste d'attente</div>
        <div v-if="overview" class="d-flex flex-column ga-2">
            <div class="d-flex flex-wrap ga-2">
                <v-chip color="red-darken-4" variant="elevated" elevation="0">{{ overview.total_count_attente }}
                    Participants en attente</v-chip>
                <v-chip color="primary-dark" variant="elevated" elevation="0">{{ overview.total_count_dossards_en_vente
                }}
                    Dossards en vente</v-chip>
                <v-chip color="green-darken-4" variant="elevated" elevation="0">{{ overview.total_count_dossards_vendus
                }}
                    Dossards vendus</v-chip>
            </div>
            <div>
                <div class="font-weight-bold">Détails par parcours</div>
                <div v-for="course in overview.details" :key="course.id_course"
                    class="spo-card pa-2 rounded bordered my-2">
                    <div class="font-weight-bold">{{ getCourseName(course.id_course) }}</div>
                    <div class="d-flex flex-wrap ga-2">
                        <v-chip color="red-darken-4" variant="elevated" elevation="0">{{ course.count_attente }}
                            Participants en attente</v-chip>
                        <v-chip color="primary-dark" variant="elevated" elevation="0">{{
                            course.count_dossards_en_vente
                            }}
                            Dossards en vente</v-chip>
                        <v-chip color="green-darken-4" variant="elevated" elevation="0">{{
                            course.count_dossards_vendus
                            }}
                            Dossards vendus</v-chip>
                    </div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    name: 'ListeAttenteBourseOverview',
    data() {
        return {
            overview: null,
        }
    },
    computed: {
        ...mapStores(useMainStore),

    },
    methods: {
        getCourseName(id) {
            return this.mainStore.module.courses.list.find(course => course.id == id).nom;
        },
        async fetchOverview() {
            let request = await AdminService.getOverviewListeAttenteBourse(this.mainStore.module.id);
            if (request) {
                this.overview = request;
            }
        }
    },
    async mounted() {
        await this.fetchOverview();
    },
}
</script>

<style lang="scss" scoped></style>